export const NONE_SORT_OPTION_VALUE = 'none';
export const BEST_MATCH_SORT_OPTION_VALUE = 'position';

export const NONE_SORT_OPTION = {
    label: __('None'),
    value: NONE_SORT_OPTION_VALUE
};
